/*
	- The theme is designed to maintain a 1:1 relationship between observer triggers and vimeo videos.
	- Each observer trigger corresponds to a specific vimeo video, ensuring precise control over video loading.
	- This setup allows for efficient management of video resources and ensures that videos are loaded only when they are about to become visible to the user.
*/

let vimeoScriptLoaded = false

export default function initvimeo() {
    const vimeoVideos = [...document.querySelectorAll('[data-vimeo-vid-id]')]
    const observerTriggers = [...document.querySelectorAll('.trigger-observer')]

    if (observerTriggers.length > 0 && vimeoVideos.length > 0) {
        observerTriggers.forEach((trigger, index) => {
            const ob = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const videoToLoad = vimeoVideos[index]
                            loadvimeoScripts(videoToLoad)
                            ob.unobserve(entry.target)
                            ob.disconnect()
                        }
                    })
                },
                { threshold: 0.1 }
            )
            ob.observe(trigger)
        })
    } else {
        loadvimeoScripts(vimeoVideos)
    }

    window._playVideo = function (el) {
        let thisID = el.dataset.videoId
        let iframeHTML = ''

        if (thisID) {
            if (el.classList.contains('vimeo')) {
                iframeHTML =
                    '<iframe class="w-full h-full vimeo-play" src="https://player.vimeo.com/video/' +
                    thisID +
                    '?title=0&byline=0&portrait=0?&autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'
            } else {
                iframeHTML =
                    '<iframe src="https://www.youtube.com/embed/' +
                    thisID +
                    '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
            }

            el.parentNode.querySelector('iframe').remove()
            el.parentNode.insertAdjacentHTML('afterbegin', iframeHTML)
            el.parentNode.classList.add('playing')
        } else {
            // console.log('No Video ID Provided')
        }
    }

    let videoTriggers = document.querySelectorAll('.inline-video-trigger')

    videoTriggers.forEach(function (el, index) {
        el.addEventListener('click', function () {
            _playVideo(el)
        })
    })
}

// Helpers
function loadvimeoScripts(video) {
    if (!video?.dataset?.vimeoVidId) {
        return
    }
    video.insertAdjacentHTML(
        'beforeend',
        `<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/${video.dataset.vimeoVidId}?${video.dataset.vimeoVidSettings}&badge=0&autopause=0&player_id=0&app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Get Shifted Video"></iframe></div>`
    )

    if (!vimeoScriptLoaded) {
        let vimeoScript = document.createElement('script')
        vimeoScript.setAttribute('async', '')
        vimeoScript.src = `https://player.vimeo.com/api/player.js`
        document.body.append(vimeoScript)
        vimeoScriptLoaded = true
    }
}
